import React from 'react';

export default function SkeletonCard({ count = 6 }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 animate-pulse pb-10">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="relative shadow rounded-xl border border-[var(--hp-border-subtle)] p-4 flex flex-col items-center text-center bg-[var(--hp-surface-card)]"
        >
          {/* Badge top-left */}
          <div className="absolute top-4 left-4 h-5 w-20 bg-[var(--hp-surface-muted)] rounded-full" />
          
          {/* Badge top-right */}
          <div className="absolute top-4 right-4 h-5 w-16 bg-[var(--hp-surface-muted)] rounded-full" />

          {/* Avatar */}
          <div className="w-16 h-16 bg-[var(--hp-surface-muted)] rounded-lg mb-4 mt-6" />

          {/* Title */}
          <div className="h-5 w-3/4 bg-[var(--hp-surface-muted)] rounded mb-2" />

          {/* Subtitle */}
          <div className="h-4 w-1/2 bg-[var(--hp-surface-muted)] rounded mb-2" />
          <div className="h-3 w-1/3 bg-[var(--hp-surface-muted)] rounded mb-4" />

          {/* Tag pill */}
          <div className="h-6 w-28 bg-[var(--hp-surface-muted)] rounded-full mb-4" />

          {/* Bottom chart placeholder */}
          <div className="w-full mt-4 border-t border-[var(--hp-border-subtle)] pt-4">
            <div className="h-[200px] w-full rounded-lg bg-[var(--hp-surface-muted)]" />
          </div>
        </div>
      ))}
    </div>
  );
}

